import {AxiosError} from 'axios';
import {GET_NOTIFICATION_DETAILS_URL} from '../../constants/apiUrls';
import {GET_NOTIFICATION_DETAILS_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface NotificationRecipientsObject {
  userUuid: string;
  name: string;
  nricFinPassport: string;
  indexNo: string;
  emailMobile: string;
  examCentre: string;
}

interface RecipientSelectionObject {
  recipients: NotificationRecipientsObject[];
  candidateTypes: string[];
  examLevels: string[];
  examCentres: string[];
  examGroups: string[];
  appointments: string[];
  individualRecipient: boolean;
  candidateRecipient: boolean;
}

interface NotificationDetailsResponse {
  recipientSelection: RecipientSelectionObject;
  notificationType: string;
  title: string;
  message: string;
  sendDate: string;
  sent: boolean;
  ackRequired: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: NotificationDetailsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  enabled: boolean;
}

export const useGetNotificationDetails = ({onSuccess, onError, uuid, enabled}: Input) => {
  const getNotificationDetails = async () => {
    const res = await axiosClient.get<NotificationDetailsResponse>(
        GET_NOTIFICATION_DETAILS_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(GET_NOTIFICATION_DETAILS_QUERY_KEY, getNotificationDetails, {
    onSuccess,
    onError,
    enabled,
  });
};
